var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page-focused",
    {
      attrs: {
        "decorative-icon-name": "faBlockQuestion",
        theme: "warning",
        title: "Sorry, We Don't Sell That",
        "custom-style": {
          "--fa-primary-color": "var(--white)",
          "--fa-secondary-color": "var(--fa-navy)",
        },
      },
    },
    [
      _c(
        "p",
        {
          staticClass: "margin-bottom-2xl",
          attrs: { slot: "copy" },
          slot: "copy",
        },
        [
          _vm._v(
            "\n    You're trying to view a product that we don't offer currently. Think we should?\n    "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "mailto:hello@fontawesome.com?subject=I have a product idea, Font Awesome",
              },
              on: {
                click: function ($event) {
                  return _vm.supportLinkClicked(
                    "icon_commission_not_found_view"
                  )
                },
              },
            },
            [_vm._v("Let us know")]
          ),
          _vm._v("\n    .\n  "),
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "text-center", attrs: { slot: "tip" }, slot: "tip" },
        [
          _vm._v("\n    Confused or is something missing?\n    "),
          _c(
            "a",
            {
              attrs: {
                href: "mailto:hello@fontawesome.com?subject=I can't find a product, Font Awesome",
              },
              on: {
                click: function ($event) {
                  return _vm.supportLinkClicked(
                    "icon_commission_not_found_view"
                  )
                },
              },
            },
            [_vm._v("Get in touch")]
          ),
          _vm._v("\n    .\n  "),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }